import { createMuiTheme } from "@material-ui/core/styles";

import "fontsource-roboto";

const theme = createMuiTheme({});

export default theme;
